module.exports = __webpack_public_path__ + "static/loma-linda-954762ed0b47a30f15ac1d7c0412c949.jpg";